import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FunctionField, ReferenceField, RecordContextProvider, SelectField, TextField } from "react-admin";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import { AttestationStatusChoices } from "utils/choices";
import { AttestationStatus } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";
import { settings } from "app";

export const MissingAttestationsMobilePanel = ({ record }) => {
  const data = record?.attestations;

  return (
    data && (
      <Accordion sx={{ width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
          <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ width: "100%" }}>
          {data.map((item, idx) => (
            <RecordContextProvider
              key={idx}
              value={item}
            >
              <div style={settings.style.shadowBoxMobile}>
                <MobileListRow
                  fields={[
                    {
                      label: "Дисциплина",
                      value: (
                        <ReferenceField
                          source="disciplineId"
                          reference={administrationRequests.getDisciplinesSelect()}
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Преподавател",
                      value: (
                        <ReferenceField
                          source="professorEmployeeId"
                          reference={employeeRequests.getProfessorsSelect()}
                          linkType={false}
                        >
                          <FunctionField render={getProfessorRecordText} />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Статус",
                      value: (
                        <SelectField
                          sx={{ color: item.status === AttestationStatus.Unverified ? "red" : "black" }}
                          source="status"
                          choices={AttestationStatusChoices}
                        />
                      ),
                    },
                  ]}
                />
              </div>
            </RecordContextProvider>
          ))}
        </AccordionDetails>
      </Accordion>
    )
  );
};
